let ctx = null;
let enabled = (() => { try { return localStorage.getItem("cq_city_sound") !== "0"; } catch { return true; } })();

function ac() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

function tone(freq, dur, type = "square", gain = 0.05, when = 0) {
  const c = ac();
  if (!c || !enabled) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  g.gain.setValueAtTime(gain, c.currentTime + when);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + when + dur);
  o.connect(g).connect(c.destination);
  o.start(c.currentTime + when);
  o.stop(c.currentTime + when + dur + 0.02);
}

export const sfx = {
  isOn: () => enabled,
  toggle() {
    enabled = !enabled;
    try { localStorage.setItem("cq_city_sound", enabled ? "1" : "0"); } catch {}
    if (enabled) tone(880, 0.08, "square", 0.04);
    return enabled;
  },
  step(alt) { tone(alt ? 160 : 130, 0.05, "triangle", 0.035); },
  click() { tone(660, 0.06, "square", 0.04); },
  door() { tone(392, 0.12, "square", 0.045); tone(523, 0.12, "square", 0.045, 0.1); tone(784, 0.18, "square", 0.045, 0.2); },
  close() { tone(523, 0.08, "square", 0.035); tone(392, 0.12, "square", 0.035, 0.07); },
  quack() { tone(300, 0.09, "sawtooth", 0.05); tone(240, 0.14, "sawtooth", 0.05, 0.09); },
  coin() { tone(988, 0.07, "square", 0.05); tone(1319, 0.18, "square", 0.05, 0.07); },
  hit() { tone(140, 0.08, "sawtooth", 0.08); tone(90, 0.12, "square", 0.06, 0.03); },
  whoosh() { tone(600, 0.05, "triangle", 0.03); tone(300, 0.08, "triangle", 0.03, 0.04); },
  ko() { [440, 392, 330, 262].forEach((f, i) => tone(f, 0.22, "square", 0.06, i * 0.16)); },
  win() { [523, 659, 784, 1047].forEach((f, i) => tone(f, 0.18, "square", 0.06, i * 0.12)); },
};

let muzakTimer = null, muzakStep = 0;
export const muzak = {
  start() {
    if (muzakTimer || !enabled) return; const c = ac(); if (!c) return;
    const chords = [[60, 64, 67, 71], [57, 60, 64, 67], [62, 65, 69, 72], [55, 59, 62, 67]]; const hz = (m) => 440 * Math.pow(2, (m - 69) / 12);
    muzakStep = 0;
    muzakTimer = setInterval(() => {
      const ch = chords[Math.floor(muzakStep / 8) % chords.length]; const n = ch[muzakStep % 4] + (muzakStep % 8 >= 4 ? 12 : 0);
      tone(hz(n), 0.35, "triangle", 0.018); if (muzakStep % 4 === 0) tone(hz(ch[0] - 12), 0.6, "sine", 0.02); if (muzakStep % 2 === 1) tone(hz(ch[2] + 12), 0.12, "sine", 0.006);
      muzakStep++;
    }, 330);
  },
  stop() { if (muzakTimer) { clearInterval(muzakTimer); muzakTimer = null; } },
};
